import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=75da3147&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75da3147')) {
      api.createRecord('75da3147', component.options)
    } else {
      api.reload('75da3147', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=75da3147&", function () {
      api.rerender('75da3147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCard.vue"
export default component.exports